/* eslint-disable complexity */
import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import Button from "@/components/wpl/button/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const CtaSection = () => {
    const intl = useIntl();

    const linkText = intl.formatMessage({
        id: "ConfluenceSoftwarePageTemplate.ctaSection.button",
        defaultMessage: "Get it free"
    });

    const buttonDataEventProps: DataEventProps = {
        "data-product-key": "confluence",
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-label": linkText,
        "data-label-english": "Get it free"
    };

    return (
        <section
            css={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "#4c9aff",

                h2: {
                    fontWeight: "500"
                },
                a: {
                    fontWeight: "500"
                },

                [media.below.sm]: {
                    padding: "16px 0"
                },

                [media.only.sm]: {
                    backgroundImage: `url("https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:515850bc-bda7-4aa4-ad46-88ea178920c0/CTA_Graphic_Left.svg?cdnVersion=1267"),
                    url("https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:c72a51b6-9afc-40e4-a9ad-7179bfc03fde/CTA_Graphic_Right.svg?cdnVersion=1267")`,
                    backgroundPosition: "center left, center right",
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundSize: "auto 207px, auto 230px",
                    padding: "64px 0"
                },

                [media.above.md]: {
                    backgroundImage: `url("https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:515850bc-bda7-4aa4-ad46-88ea178920c0/CTA_Graphic_Left.svg?cdnVersion=1267"),
                    url("https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:c72a51b6-9afc-40e4-a9ad-7179bfc03fde/CTA_Graphic_Right.svg?cdnVersion=1267")`,
                    backgroundPosition: "center left, center right",
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundSize: "auto 243px, auto 243px",
                    padding: "64px 0"
                }
            })}
        >
            <h2
                css={css({
                    color: "#091e42",
                    margin: "0",
                    padding: "16px",
                    textAlign: "center",

                    [media.below.sm]: {
                        fontSize: `${token("space.400")}`
                    },

                    [media.above.sm]: {
                        fontSize: "2.75rem"
                    },

                    [media.above.lg]: {
                        fontSize: `${token("space.600")}`
                    }
                })}
            >
                {intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.ctaSection.header",
                    defaultMessage: "Start free with Confluence"
                })}
            </h2>
            <div
                css={css({
                    padding: "16px"
                })}
            >
                <Button
                    color="yellow"
                    type="primary"
                    size="large"
                    url={useLocalizedHref(
                        "/try/cloud/signup?bundle=confluence&edition=free"
                    )}
                    text={linkText}
                    dataEventProps={buttonDataEventProps}
                />
            </div>
        </section>
    );
};

export default CtaSection;
